import { isBrowser } from '~/shared/utils/platform';

export default function getUrl(path: string) {
    return new URL(
        (isBrowser ? '/api/proxy' : '/api') + path,
        isBrowser ? window.location.origin : process.env.API_URL
    );
}
